// extracted by mini-css-extract-plugin
export default {"faq":"faq_faq__YzEdj","AccordionWrp":"faq_AccordionWrp__x4IBv","icn":"faq_icn__mqasH"};